import { Building } from "../models/Building";
import { DeviceImprox } from "../models/DeviceImprox";
import { Door } from "../models/Door";
import { EventType } from "../models/EventType";
import { ListQuery } from "../models/ListQuery";
import { Site } from "../models/Site";
import { Zone } from "../models/Zone";
import { getBuildings } from "../services/buildingService";
import { getDeviceImprox } from "../services/deviceImproxService";
import { getDoors } from "../services/doorService";
import { getEnrolments } from "../services/enrolmentService";
import { getEventTypes } from "../services/eventTypeService";
import { getSites } from "../services/siteService";
import { getZones } from "../services/zoneService";
import { appendFilter } from "./filters";
import {Translator} from "../contexts/translator";

// Fetch Master Data
const fetchMasterData = async (ids: string[],translate:Translator, listParameters?: ListQuery ) => {
    return await getEnrolments(translate, {
        ...listParameters,
        filters: appendFilter(
            ids.toString(),
            "Recipients",
            "id",
            listParameters?.filters ?? [],
            "=in=")
    });
};

export const getRecipientData = async (translate:Translator, toRecipients: string[], ccRecipients: string[]) => {
    const toRecipientsData = await fetchMasterData(toRecipients, translate)
        .then(result => { return result.rows })

    const ccRecipientsData = ccRecipients.length > 0
        ? await fetchMasterData(ccRecipients, translate)
            .then((result) => { return result.rows })
        : await Promise.resolve();

    return { toRecipientsData: toRecipientsData, ccRecipientsData: ccRecipientsData };
}

export const getEventsData = async (eventIds: string[], translate, listParameters?: ListQuery): Promise<EventType[]> => {
    const events = await getEventTypes(translate, {
        ...listParameters,
        filters: appendFilter(
            eventIds.toString(),
            "Events",
            "id",
            listParameters?.filters ?? [],
            "=in=")
    }).then((result) => {
        return result.rows;
    })
        .catch((errors) => {
            throw errors;
        });
    return events;
};

// Fetch Site Data
const fetchSitesData = async (ids: string[], listParameters?: ListQuery) => {
    return await getSites({
        ...listParameters,
        filters: appendFilter(
            ids.toString(),
            "Sites",
            "id",
            listParameters?.filters ?? [],
            "=in=")
    });
};

export const getSitesData = async (SiteIds: string[]): Promise<Site[]> => {
    const sites = fetchSitesData(SiteIds)
        .then((result) => {
            return result.rows;
        })
        .catch((errors) => {
            throw errors;
        });

    return sites;
};

// Fetch Buildings Data
const fetchBuildingsData = async (ids: string[], listParameters?: ListQuery) => {
    return await getBuildings({
        ...listParameters,
        filters: appendFilter(
            ids.toString(),
            "Buildings",
            "id",
            listParameters?.filters ?? [],
            "=in=")
    });
};

export const getBuildingsData = async (buildingIds: string[]): Promise<Building[]> => {
    const buildings = fetchBuildingsData(buildingIds)
        .then((result) => {
            return result.rows;
        })
        .catch((errors) => {
            throw errors;
        });

    return buildings;
}

// Fetch Zones Data
const fetchZonesData = async (ids: string[], listParameters?: ListQuery) => {
    return await getZones({
        ...listParameters,
        filters: appendFilter(
            ids.toString(),
            "Zones",
            "id",
            listParameters?.filters ?? [],
            "=in=")
    });
};

export const getZonesData = async (zoneIds: string[]): Promise<Zone[]> => {
    const zones = fetchZonesData(zoneIds)
        .then((result) => {
            return result.rows;
        })
        .catch((errors) => {
            throw errors;
        });

    return zones;
}

// Fetch Doors Data
const fetchDoorsData = async (ids: string[], listParameters?: ListQuery) => {
    return await getDoors({
        ...listParameters,
        filters: appendFilter(
            ids.toString(),
            "Doors",
            "id",
            listParameters?.filters ?? [],
            "=in=")
    });
};

export const getDoorsData = async (eventIds: string[]): Promise<Door[]> => {
    const doors = fetchDoorsData(eventIds)
        .then(result => {
            return result.rows;
        })
        .catch((errors) => {
            throw errors;
        });

    return doors;
}

// Fetch Devices Data
const fetchDevicesData = async (ids: string[], listParameters?: ListQuery) => {
    return await getDeviceImprox({
        ...listParameters,
        filters: appendFilter(
            ids.toString(),
            "Devices",
            "id",
            listParameters?.filters ?? [],
            "=in=")
    });
};

export const getDevicesData = async (deviceIds: string[]): Promise<DeviceImprox[]> => {
    const devices = fetchDevicesData(deviceIds)
        .then(result => {
            return result.rows;
        })
        .catch((errors) => {
            throw errors;
        });

    return devices;
}
